/**
 * Labels for the comparison period selector.
 *
 * House nomenclature is Y-1: the same period, previous YEAR. Not N-1, which reads as
 * "the previous period" and is exactly the reference this option replaces.
 * Backend twin (the date arithmetic): backend/utils/visitsComparison.js — keep in sync.
 */
export const COMPARISON_MODES = {
  PREVIOUS_YEAR: 'previous-year',
  PREVIOUS_PERIOD: 'previous-period',
};

export const DEFAULT_COMPARISON_MODE = COMPARISON_MODES.PREVIOUS_YEAR;

// `option` labels the selector, `tile` is the sentence under each stat tile.
export const COMPARISON_LABELS = {
  [COMPARISON_MODES.PREVIOUS_YEAR]: {
    option: 'Y-1 (même période)',
    tile: 'sur la même période un an avant',
    short: 'vs Y-1',
  },
  [COMPARISON_MODES.PREVIOUS_PERIOD]: {
    option: 'Période précédente',
    tile: 'sur la période précédente',
    short: 'vs période précédente',
  },
};

export const comparisonLabel = (mode, key = 'tile') =>
  (COMPARISON_LABELS[mode] || COMPARISON_LABELS[DEFAULT_COMPARISON_MODE])[key];
